/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Last_Event_TimecodeInputs */



/**
* | output |
* | --- |
* | "Last event timecode" |
*
* @param {Last_Event_TimecodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const last_event_timecode = /** @type {((inputs?: Last_Event_TimecodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Last_Event_TimecodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Timecode du dernier événement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitcode des letzten Ereignisses")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codice temporale dell'ultimo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Последний временной код события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Código de tiempo del último evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("上次事件时间码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最後のイベントのタイムコード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंतिम घटना का समय कोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Código de tempo do último evento")
	return /** @type {LocalizedString} */ ("Last event timecode")
});